import React from 'react';
import './courses.css';
import htmlpix from '../coursepix/html.png';
import bootstrap from '../coursepix/bootstrap.png';
import javascript from '../coursepix/javascript.png';
import react from '../coursepix/react.jpg';
import nodejs from '../coursepix/nodejs.png';
import others from '../coursepix/others.jpg';
// import { Link } from 'react-router-dom';


const data = [
  {
    name: 'HTML',
    pix: htmlpix,
    about:
      'HTML is the standard markup language for Web pages.\n With HTML you can create your own Website.CSS describes how HTML elements should be displayed.We will teach you CSS from basic to advanced.\n HTML is easy to learn - You will enjoy it!',
  },

  {
    name: 'BOOTSTRAP',
    pix: bootstrap,
    about:
      'Bootstrap is a free, open source front-end development framework for the creation of websites and web apps.',
  },
  {
    name: 'Javascript',
    pix: javascript,
    about:
      'JavaScript is a text-based programming language used both on the client-side and server-side that allows you to make web pages interactive.',
  },
  {
    name: 'React',
    pix: react,
    about:
      'React (also known as React.js or ReactJS) is a free and open-source front-end JavaScript library for building user interfaces based on UI components. React is in high demand.',
  },
  {
    name: 'Nodejs',
    pix: nodejs,
    about:
      'Node allows developers to write JavaScript code that runs directly in a computer process itself instead of in a browser. Node can, therefore, be used to write server-side applications with access to the operating system, file system, and everything else required to build fully-functional applications',
  },
  {
    name: '& Others',
    pix: others,
    about:
      'Coding is one of the most valuable skills to learn today. You can not only build any idea you have and see it come to life, but you can also improve your future. We have sophisticated structures and staff ready to deliver.',
  },
];
const Courses = () => {
  return (
    <div className="baba">
      <h1 className="apply">
        <a href="#apply">Apply</a>
      </h1>

      {/* <h5>We Teach </h5> */}

      <div className="hhh">
        <h5>We Teach </h5>
      </div>

      {data.map(({ name, pix, about }, index) => {
        return (
          <div key={index} className="grid">
            <div className="image">
              <img className="imagee" src={pix} alt="Avatar" />
            </div>
            <div>
              <h5 className="name">{name}</h5>
              <p className="about">{about}</p>
            </div>
          </div>
        );
      })}

      <div className="alli">
        <span className=" fa fa-arrow-right"></span>
        <a
          id="apply"
          href="https://wa.me/2348130757003?text=Hi ,I want to learn."
          target="_blank"
          rel="noreferrer"
        >
          &nbsp; Apply here
        </a>
      </div>
    </div>
  );
};

export default Courses;
